import React from 'react'
import Button from '../../../components/Button'
import styles from '../styles.module.scss'

export default function Footer({ goHome, onSettings }) {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerLeft}>
        <Button mode='white' className={styles.footerBtn} onClick={onSettings}>Настройки</Button>
        <Button mode='white' className={styles.footerBtn}>Расписание преподавателей</Button>
      </div>
      <div className={styles.footerRight}>
        <Button mode='white' className={styles.footerBtn}>Сохранить</Button>
        <Button mode='white' className={styles.footerBtn}>Сохранить как...</Button>
        <Button mode='white' className={styles.footerBtn} onClick={goHome}>Закрыть</Button>
      </div>
    </footer>
  )
}
